import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4404a7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "vs", -1))
const _hoisted_2 = { class: "text-wrap" }
const _hoisted_3 = { class: "text-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "General enemigo matado", -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "General enemigo matado", -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "partida-en-juego" }

import { ref, onMounted } from "vue";
import { PartidaTorneoMasDTO } from "@/interfaces/Partidas";
import { useRouter } from "vue-router";
import { formatFechaSpa } from "@/utils/Fecha";
import { getListaById } from "@/services/ListasService";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalValidarPartida from "@/components/ResultadosTorneos/ModalValidarPartida.vue";
import { updatePartidaTorneo } from "@/services/PartidaTorneoService";
import { UpdatePartidaTorneoDTO } from "@/interfaces/Live";
import ModalEditarPartida from "@/components/ResultadosTorneos/ModalEditarPartida.vue";
import { ListaDTO } from "@/interfaces/Usuario";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaTorneoMasLive',
  props: {
    match: {},
    idUsuario: {},
    mesa: {},
    completa: { type: Boolean },
    editarPartidaPJ: { type: Boolean },
    soloValidarPJ: { type: Boolean }
  },
  setup(__props: any) {

const isLoading = ref(true);
const error = ref<string | null>(null);
const router = useRouter();
const listaData = ref<string>("");
const listaDTO = ref<ListaDTO>();
const nickJugador = ref<string>("");
const isModalListaVisible = ref<boolean>(false);
const currentEjercito = ref<string>();

const fechaPartidaFormateada = ref<string>("");

//Variables para el modal validar partida
const isModalValidarVisible = ref<boolean>(false);
const idPartidaSeleccionada = ref<number>();
const usuarioSeleccionado = ref<1 | 2>();

//Variables para el modal de editar partida para validar (ModalEditarPartida)
const isModalEditarPartidaVisible = ref<boolean>(false);
const idUsuarioSelected = ref<number>(0);
const partidaSelected = ref<PartidaTorneoMasDTO>({
  escenarioPartida: null,
  fechaPartida: "",
  ganadorPartidaTorneo: null,
  idPartidaTorneo: 0,
  idTorneo: 0,
  idUsuario1: 0,
  idUsuario2: 0,
  liderMuertoUsuario1: null,
  liderMuertoUsuario2: null,
  nick1: "",
  nick2: "",
  numeroRonda: 0,
  partidaValidadaUsuario1: null,
  partidaValidadaUsuario2: null,
  resultadoUsuario1: null,
  resultadoUsuario2: null,
  listasJugador1: [],
  listasJugador2: [],
});

const props = __props;

const initializeComponent = async () => {
  try {
    isLoading.value = true;
    fechaPartidaFormateada.value = await formatFechaSpa(
      props.match.fechaPartida
    );
  } catch (err) {
    console.error(error);
    error.value = (err as Error).message;
    router.push({ name: "error" });
  } finally {
    isLoading.value = false;
  }
};

const verLista = async (idLista: number, nick: string) => {
  isLoading.value = true;
  if (idLista) {
    try {
      const listaResponse = await getListaById(idLista);
      listaDTO.value = listaResponse.data;
      if (listaDTO.value != undefined)
        listaData.value = listaDTO.value.listaData ?? "";
      nickJugador.value = nick;
      currentEjercito.value = listaDTO.value?.ejercito;
      isModalListaVisible.value = true;
    } catch (error) {
      console.error(error);
      isModalListaVisible.value = false;
      isLoading.value = false;
    } finally {
      isLoading.value = false;
    }
  }
};

const getGanador = (partida: PartidaTorneoMasDTO) => {
  if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
    return partida.nick1;
  } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
    return partida.nick2;
  } else {
    return "Empate";
  }
};
const getColorGanador = (partida: PartidaTorneoMasDTO, idUsuario: number) => {
  if (partida.ganadorPartidaTorneo === idUsuario) {
    return "green";
  } else if (partida.ganadorPartidaTorneo != null) {
    return "red";
  } else {
    return "orange";
  }
};

const abrirModalValidar = (match: PartidaTorneoMasDTO) => {
  idPartidaSeleccionada.value = match.idPartidaTorneo;
  isModalValidarVisible.value = true;
  props.idUsuario === match.idUsuario1
    ? (usuarioSeleccionado.value = 1)
    : (usuarioSeleccionado.value = 2);
};

const confirmarValidar = async () => {
  if (idPartidaSeleccionada.value) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: idPartidaSeleccionada.value,
    };

    if (usuarioSeleccionado.value === 1) body.partidaValidadaUsuario1 = true;
    else body.partidaValidadaUsuario2 = true;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error("confirmarValidar", error);
    } finally {
      isModalValidarVisible.value = false;
      window.location.reload();
    }
  }
};

const cerrarModalValidar = () => {
  isModalValidarVisible.value = false;
};

//Metodo que recoje el click del botón Validar Resultado y prepara los datos para enviar al backend
const editPartida = (partida: PartidaTorneoMasDTO, idUsuario: number) => {
  partidaSelected.value = partida;

  if (idUsuario === partida.idUsuario1) idUsuarioSelected.value = 1;
  else idUsuarioSelected.value = 2;

  isModalEditarPartidaVisible.value = true;
};

const confirmarEditarPartida = async (partida: PartidaTorneoMasDTO) => {
  if (partida) {
    const body: UpdatePartidaTorneoDTO = {
      idPartidaTorneo: partida.idPartidaTorneo,
      resultadoUsuario1: partida.resultadoUsuario1,
      resultadoUsuario2: partida.resultadoUsuario2,
      escenarioPartida: partida.escenarioPartida,
      liderMuertoUsuario1: partida.liderMuertoUsuario1,
      liderMuertoUsuario2: partida.liderMuertoUsuario2,
    };

    if (partida.partidaValidadaUsuario1) body.partidaValidadaUsuario1 = true;
    else body.partidaValidadaUsuario2 = true;

    try {
      await updatePartidaTorneo(body);
    } catch (error) {
      console.error(error);
    } finally {
      isModalEditarPartidaVisible.value = false;
      window.location.reload();
    }
  }
};

const cerrarModalEditarPartida = () => {
  isModalEditarPartidaVisible.value = false;
};

const verProfileUser = (idUser: number) => {
  if (navigator.vibrate) {
    navigator.vibrate(500);
    router.push({ name: "detalle-jugador", params: { idUsuario: idUser } });
  } else {
    console.warn("La vibración no es compatible en este navegador.");
  }
};

onMounted(initializeComponent);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ props }) => [
        _createVNode(_component_v_card, _mergeProps(props, { class: "match-card mt-3" }), {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, {
              class: "text-center text-h5 text-wrap",
              style: {"font-family":"'Roboto', sans-serif","color":"#ffcc00"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.mesa), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_title, { class: "text-wrap match-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "5",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (verProfileUser(_ctx.match.idUsuario1)), ["prevent"])),
                      class: "player text-left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: _ctx.match.idUsuario1 === _ctx.idUsuario }])
                        }, _toDisplayString(_ctx.match.nick1), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "score text-center marcador"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1,
                        _createElementVNode("p", null, _toDisplayString(_ctx.match.resultadoUsuario1) + "-" + _toDisplayString(_ctx.match.resultadoUsuario2), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "5",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (verProfileUser(_ctx.match.idUsuario2)), ["prevent"])),
                      class: "player text-right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-wrap", { highlight: _ctx.match.idUsuario2 === _ctx.idUsuario }])
                        }, _toDisplayString(_ctx.match.nick2), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "match-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center",
                  class: "army-buttons"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-left"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.listasJugador1 ?? [], (lista, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: lista?.idLista ?? index
                          }, [
                            (lista.idLista !== undefined)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  block: "",
                                  class: "army-btn",
                                  onClick: ($event: any) => (verLista(lista.idLista, _ctx.match.nick1)),
                                  style: {"font-size":"10px"},
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_2, _toDisplayString(lista.ejercito), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-right"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.listasJugador2 ?? [], (lista, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: lista?.idLista ?? index
                          }, [
                            (lista.idLista !== undefined)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  block: "",
                                  class: "army-btn",
                                  onClick: ($event: any) => (verLista(lista.idLista, _ctx.match.nick2)),
                                  style: {"font-size":"10px"},
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(lista.ejercito), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-3 match-scenario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          class: "location-icon"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-map-marker")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Escenario: "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.match.escenarioPartida || "No disponible"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("p", _hoisted_5, [
                              (_ctx.match.liderMuertoUsuario1 === true)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-check-circle")
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.match.liderMuertoUsuario1 === false)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-close-circle")
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-dots-horizontal")
                                      ]),
                                      _: 1
                                    }))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("p", _hoisted_7, [
                              (_ctx.match.liderMuertoUsuario2 === true)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-check-circle")
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.match.liderMuertoUsuario2 === false)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-close-circle")
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-dots-horizontal")
                                      ]),
                                      _: 1
                                    }))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.completa)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      align: "center",
                      class: "match-outcome"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              color: getColorGanador(_ctx.match, _ctx.match.idUsuario1),
                              class: "outcome-chip"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.match.nick1 === getGanador(_ctx.match))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Victoria"))
                                  : (_ctx.match.nick2 === getGanador(_ctx.match))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Derrota"))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_10, "Empate"))
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "text-center"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              color: getColorGanador(_ctx.match, _ctx.match.idUsuario2),
                              class: "outcome-chip"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.match.nick2 === getGanador(_ctx.match))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Victoria"))
                                  : (_ctx.match.nick1 === getGanador(_ctx.match))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Derrota"))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_13, "Empate"))
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_14, [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-sword-cross")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" Partida en juego...")
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                (!_ctx.completa && _ctx.editarPartidaPJ && !_ctx.soloValidarPJ)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              color: "success",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (editPartida(_ctx.match, _ctx.idUsuario)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Validar Resultado ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (!_ctx.completa && _ctx.soloValidarPJ)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "success",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (abrirModalValidar(_ctx.match)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Validar Resultado ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_row, { key: 4 }))
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, { class: "my-3" }),
    (isModalListaVisible.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 0,
          listaData: listaData.value,
          nickJugador: nickJugador.value,
          ejercito: currentEjercito.value,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (isModalListaVisible.value = false))
        }, null, 8, ["listaData", "nickJugador", "ejercito"]))
      : _createCommentVNode("", true),
    (isModalEditarPartidaVisible.value)
      ? (_openBlock(), _createBlock(ModalEditarPartida, {
          key: 1,
          isVisible: isModalEditarPartidaVisible.value,
          partida: partidaSelected.value,
          idUsuario: idUsuarioSelected.value,
          onConfirmar: confirmarEditarPartida,
          onCerrar: cerrarModalEditarPartida
        }, null, 8, ["isVisible", "partida", "idUsuario"]))
      : _createCommentVNode("", true),
    (isModalValidarVisible.value)
      ? (_openBlock(), _createBlock(ModalValidarPartida, {
          key: 2,
          isVisible: isModalValidarVisible.value,
          idPartidaTorneo: idPartidaSeleccionada.value,
          onConfirmar: confirmarValidar,
          onCerrar: cerrarModalValidar
        }, null, 8, ["isVisible", "idPartidaTorneo"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isLoading).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})